import { BaseAPI } from '../manager/base';
import apiClient from '../apiClient';
import type { BaseResponse, ListResponse } from '../../types/base.dto';
import { ExternalReport } from '../../types/process/external-report';

export class ExternalReportAPI extends BaseAPI<ExternalReport> {
  constructor() {
    super('/external-reports');
  }

  /**
   * 获取订单关联的风控报告列表
   * @param orderNo 订单号
   * @param statusOnly 是否只获取状态（不返回content）
   */
  async getReports(orderNo: string, statusOnly: boolean = false): Promise<ExternalReport[]> {
    try {
      const response = await apiClient.get<BaseResponse<ExternalReport[]>>(`${this.endpoint}/${orderNo}`, {
        params: { status_only: statusOnly }
      });
      
      if (response.data.code === 200 && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error('Fetch reports failed:', error);
      return [];
    }
  }

  /**
   * 生成风控报告
   * @param orderNo 订单号
   */
  async generateReport(orderNo: string): Promise<BaseResponse<any>> {
    const response = await apiClient.post(`${this.endpoint}/generate/${orderNo}`);
    return response.data;
  }
}

export const externalReportApi = new ExternalReportAPI();

export default externalReportApi;
